export enum AnnualMinimumProvenanceTypeIdEnum {
  Actual = 1,
  Estimated = 2
}
